import { takeLatest, put, all, call } from 'redux-saga/effects';
import AddEmployeeActionType from './AddEmployee.types';
import { addEmployee, getEmployeeNameAndIDAPI } from './AddEmployee.services';
import {
	addEmployeeFailure,
	addEmployeeSuccess,
	getEmployeeNameAndIDSuccess,
	getEmployeeNameAndIDFailure,
} from './AddEmployee.action';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

export function* addNewEmployee(payload: any) {
	try {
		const addNewEmployeeData = {
			empID: payload.payload.empID,
			employeeName: payload.payload.employeeName,
			Designation: payload.payload.Designation,
			employeeGender: payload.payload.employeeGender,
			employeeDOB: payload.payload.employeeDOB,
			employeePhone: payload.payload.employeePhone,
			employeeBloodGroup: payload.payload.employeeBloodGroup,
			employeePassword: payload.payload.employeePassword,
			isManager: payload.payload.isManager,
			branchID: payload.payload.branchID,
			sectionID: payload.payload.sectionID,
			casualLeave: payload.payload.casualLeave,
			medicalLeave: payload.payload.medicalLeave,
			privilegeLeave: payload.payload.privilegeLeave,
			organisationID: payload.payload.organisationID,
		};
		const encryptedData = encryptData(
			addNewEmployeeData,
			AddEmployeeActionType.ADD_EMPLOYEE_KEY,
		);
		// @ts-ignore
		const responseData = yield call(addEmployee as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				console.log('Received failure response');
				yield put(addEmployeeFailure(responseData.data));
			} else {
				console.log('Received success response');
				yield put(addEmployeeSuccess(responseData.data));
			}
		}
	} catch (error) {
		console.error('Error in fetchAddEmployee:', error);
		yield put(addEmployeeFailure(error));
	}
}
export function* getEmployeeNameAndID(payload: any) {
	try {
		const key = 'getEmployeeKey';
		const employeeID = { employeeID: payload };
		const encryptedData = encryptData(employeeID, key);
		// @ts-ignore
		const responseData = yield call(getEmployeeNameAndIDAPI as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				yield put(getEmployeeNameAndIDFailure(responseData.data));
			} else {
				yield put(getEmployeeNameAndIDSuccess(responseData.data));
			}
		}
	} catch (error) {
		console.error('Error in fetchGetEmployeeNameAndID:', error);
		yield put(getEmployeeNameAndIDFailure(error));
	}
}

export function* onAddEmployeeStart(): Generator<any, void, any> {
	yield takeLatest(AddEmployeeActionType.ADD_EMPLOYEE_START as any, addNewEmployee);
}

export function* onGetEmployeeNameAndIDStart(): Generator<any, void, any> {
	yield takeLatest(
		AddEmployeeActionType.GET_EMPLOYEE_NAME_AND_ID_START as any,
		getEmployeeNameAndID,
	);
}

export function* addEmployeeSaga(): Generator<any, void, any> {
	yield all([call(onAddEmployeeStart), call(onGetEmployeeNameAndIDStart)]);
}
